import { render, staticRenderFns } from "./PoliciesDashboard.vue?vue&type=template&id=3f91e948&"
import script from "./PoliciesDashboard.vue?vue&type=script&lang=js&"
export * from "./PoliciesDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports